import { defineComponent } from 'vue';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import DriverscloudComponent from "./../BackupDriver/DriverscloudComponent.vue";
import { VueSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { createPinia } from 'pinia';

let glan: string = "fr";

const mixin = defineComponent({
    components: { DriverscloudComponent },
    data() {
        return {
          lan:"fr"
        };
    },
    created() {
      
    },

    mounted() {
        this.lan = glan;
    },
    methods: {
            
    }

});


export class BackupDriverComponent {
    public constructor() {
    }

    public Init(lan: string) {
        glan = lan;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        const connection = new HubConnectionBuilder().withUrl('/SignalRDriversCloud').build();
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}
(<any>(window)).BackupDriverComponent = function () { return new BackupDriverComponent(); };